import * as React from 'react';
import styled from 'styled-components';
import {Plan} from '../AccountCheckout.type';
import {formatCurrency} from '../AccountCheckout.map';

const BenefitsContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const PlanHeader = styled.div`
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 20px;
`;

const PlanName = styled.h2`
  margin: 0 0 10px 0;
  color: #333;
  font-size: 28px;
`;

const PlanPrice = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 5px;
  margin-bottom: 5px;
`;

const Currency = styled.span`
  font-size: 24px;
  color: #666;
`;

const Price = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: #4caf50;
`;

const PlanDescription = styled.p`
  color: #666;
  font-size: 16px;
  margin: 10px 0 0 0;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  i {
    color: #4caf50;
    font-size: 24px;
    flex-shrink: 0;
  }

  span {
    color: #333;
    font-size: 16px;
    line-height: 1.5;
  }
`;

const HighlightBadge = styled.div`
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
`;

interface PlanBenefitsProps {
  plan: Plan;
}

export const PlanBenefits: React.FC<PlanBenefitsProps> = ({plan}) => {
  const benefits = [
    'Acesso ilimitado a todos os treinos',
    'Planos personalizados para seu objetivo',
    'Acompanhamento de progresso em tempo real',
    'Suporte via chat com profissionais',
    'Acesso ao app mobile (iOS e Android)',
    'Biblioteca de exercícios com vídeos',
    'Comunidade exclusiva de alunos',
    'Atualizações constantes de conteúdo',
  ];

  return (
    <BenefitsContainer>
      <PlanHeader>
        <PlanName>{plan.name}</PlanName>
        <PlanPrice>
          <Currency>R$</Currency>
          <Price>
            {parseFloat(String(plan.value)).toFixed(2).replace('.', ',')}
          </Price>
        </PlanPrice>
        {plan.installments > 1 && (
          <div style={{color: '#666', fontSize: '14px'}}>
            ou {plan.installments}x de{' '}
            {formatCurrency(parseFloat(String(plan.value)) / plan.installments)}
          </div>
        )}
        {plan.description && (
          <PlanDescription>{plan.description}</PlanDescription>
        )}
        <HighlightBadge>✨ Melhor Escolha</HighlightBadge>
      </PlanHeader>

      <BenefitsList>
        {benefits.map((benefit, index) => (
          <BenefitItem key={index}>
            <i className="material-icons">check_circle</i>
            <span>{benefit}</span>
          </BenefitItem>
        ))}
      </BenefitsList>
    </BenefitsContainer>
  );
};
